import createStore from '@/stores/store';

// Create a store for the zoom level
export const playerPlaybackRateStore = createStore<number>(1);

export enum PlayRateValue {
  HALF = 0.5,
  NORMAL = 1,
  ONE_POINT_FIVE = 1.5,
  DOUBLE = 2
}

export const MIN_PLAYBACK_LEVEL = PlayRateValue.HALF;
export const MAX_PLAYBACK_LEVEL = PlayRateValue.DOUBLE;

/**
 * Set the zoom level to a specific value
 * @param value - The new zoom level value
 */
export function setPlayBackSpeed(value: number) {
  // Ensure the zoom level is within the allowed range
  const clampedValue = Math.max(MIN_PLAYBACK_LEVEL, Math.min(MAX_PLAYBACK_LEVEL, value));
  playerPlaybackRateStore.set(() => clampedValue);
}
